module.exports = __webpack_public_path__ + "img/icon-fb-lg.ff6386c0.png";